export default "__VITE_ASSET__6b86b2d9__"